export default "__VITE_ASSET__f8de28e7__"